import AppHealthTest from "./AppHealthTest";
import WorkflowSmokeTest from "./WorkflowSmokeTest";
import WorkflowSearchSmokeTest from "./WorkflowSearchSmokeTest";
import ColumnsFilterSmokeTest from "./ColumnsFilterSmokeTest";
import ActionSmokeTest from "./ActionSmokeTest";
// import ExportPDFTest from "./ExportPDFTest";
// import ReceiveSampleTest from "./ReceiveSampleTest";
// import ResourcesAvailabilityTest from "./ResourcesAvailabilityTest";

const tests = api => [
  new AppHealthTest(api),
  new WorkflowSmokeTest(api),
  new WorkflowSearchSmokeTest(api),
  new ColumnsFilterSmokeTest(api),
  new ActionSmokeTest(api)
  // new WorkflowSmokeTest(api),
  // new ActionSmokeTest(api),
  // new ReceiveSampleTest(api),
  // new ResourcesAvailabilityTest(api),
  // new ExportPDFTest(api),
];

export default tests;
